export default __webpack_public_path__ + "125bb34f24bf269d84cf4af4ffbda689.ttf";